export default "__VITE_ASSET__DqPiShbo__"